/** Scoped Modus text-input overrides for read-only palette stop rows. */
export const PALETTE_STOP_MODUS_OVERRIDES = `
  .palette-stop-viewer modus-wc-text-input input {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    padding: 0 !important;
    height: auto !important;
    min-height: auto !important;
    cursor: default !important; /* Read-only: show as not clickable. */
  }

  .palette-stop-viewer modus-wc-text-input label {
    margin-bottom: 0 !important;
  }

  .palette-stop-viewer
    modus-wc-text-input:not([include-search]):not([include-clear])
    input {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .palette-stop-viewer modus-wc-text-input {
    margin-bottom: 0 !important;
  }

  .palette-stop-viewer modus-wc-text-input .modus-wc-input-label {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  .palette-stop-viewer modus-wc-text-input:not([label]) .modus-wc-input-label,
  .palette-stop-viewer modus-wc-text-input .modus-wc-input-label:empty {
    display: none !important;
    margin: 0 !important;
    padding: 0 !important;
    min-height: 0 !important;
    height: 0 !important;
  }

  .palette-stop-viewer .palette-stop-modus-input {
    align-self: center;
    flex-shrink: 0;
    margin-bottom: 0 !important;
    background-color: var(--modus-wc-color-base-100, #f1f1f6) !important;
    border: none !important;
    box-shadow: none !important;
  }

  .palette-stop-viewer .palette-stop-modus-input--editable input {
    cursor: text !important; /* Editable rows: restore the text caret. */
  }
`;
